import React from 'react';
import useSocket from '../socket/useSocket';
import useUser from '../global/useUser';
import { invalidateBusinessStripeSummary } from '../../services/business';
import { canManageStripeAccount } from '../../helpers/businesses';

function useStripeAccountSocket() {
  const socket = useSocket();
  const { user } = useUser();

  const isEnabled = React.useMemo(() => canManageStripeAccount(user), [user]);

  React.useEffect(() => {
    if (!isEnabled) return undefined;

    const onAccountUpdated = () => {
      invalidateBusinessStripeSummary();
    };

    socket.on('stripeAccountUpdated', onAccountUpdated);

    return () => {
      socket.off('stripeAccountUpdated', onAccountUpdated);
    };
  }, [socket, isEnabled]);
}

export default useStripeAccountSocket;
